"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutTableRowInfo = exports.LayoutTableCellBackgroundInfo = void 0;
var tslib_1 = require("tslib");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var list_1 = require("@devexpress/utils/lib/utils/list");
var search_1 = require("@devexpress/utils/lib/utils/search");
var layout_table_cell_info_1 = require("./layout-table-cell-info");
var LayoutTableCellBackgroundInfo = (function (_super) {
    tslib_1.__extends(LayoutTableCellBackgroundInfo, _super);
    function LayoutTableCellBackgroundInfo(bound, color) {
        var _this = _super.call(this, bound.x, bound.y, bound.width, bound.height) || this;
        _this.color = color;
        return _this;
    }
    return LayoutTableCellBackgroundInfo;
}(rectangle_1.Rectangle));
exports.LayoutTableCellBackgroundInfo = LayoutTableCellBackgroundInfo;
var LayoutTableRowInfo = (function (_super) {
    tslib_1.__extends(LayoutTableRowInfo, _super);
    function LayoutTableRowInfo(parentTable, bound, rowIndex) {
        var _this = _super.call(this, bound.x, bound.y, bound.width, bound.height) || this;
        _this.parentTable = parentTable;
        _this.rowCells = [];
        _this.backgroundInfos = [];
        _this.rowIndex = rowIndex;
        return _this;
    }
    LayoutTableRowInfo.prototype.isBoundWithPrev = function () {
        return list_1.ListUtils.indexBy(this.rowCells, function (cell) { return !cell.boundFlags.get(layout_table_cell_info_1.TableCellBoundFlags.StartOnThisColumn); }) >= 0;
    };
    LayoutTableRowInfo.prototype.getCellIndexByExactlyCellGridIndex = function (cellGridIndex) {
        return search_1.SearchUtils.binaryIndexOf(this.rowCells, function (cell) { return cell.cellGridIndex - cellGridIndex; });
    };
    LayoutTableRowInfo.prototype.getCellByExactlyCellGridIndex = function (cellGridIndex) {
        var cellIndex = this.getCellIndexByExactlyCellGridIndex(cellGridIndex);
        return cellIndex < 0 ? null : this.rowCells[cellIndex];
    };
    return LayoutTableRowInfo;
}(rectangle_1.Rectangle));
exports.LayoutTableRowInfo = LayoutTableRowInfo;
